export enum SsoType {
    Email = 'email',
    Google = 'google',
    Apple = 'apple',
}
